import React from "react";
import { LoginForm } from "../../components/Login/Login";

const Login: React.FC<{ setPathname: () => void }> = ({ setPathname }) => (
  <LoginForm setPathname={setPathname} />
);

export default Login;
